/*
 * @Author: your name
 * @Date: 2022-11-10 11:18:27
 * @LastEditTime: 2023-07-05 11:25:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/pages/InductiveManage/SelectEnv.tsx
 */
import React, { useState, useEffect } from 'react';
import { Row, Col, Spin } from 'sup-ui';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
// import nanotube from 'root/assets/images/illustrator_nanotube@2x.png';
import alone from 'root/assets/images/standalone@2x.png';
import colony from 'root/assets/images/illustrator_colony@2x.png';
import { updateNanotubeDataApi, getNanotubeDataApi, checkNanotubeApi } from 'root/services/nanotube';
import { useNavigate } from 'react-router-dom';
import { reducerStates } from 'root/store/types';
import messages from './messages';
import styles from './index.less';
import { changeStatus, chagnePage } from 'root/store/nanotube/actions';
import { envManage } from 'root/pages/EnvManage/store/actions';

interface IEnvType {
  id: string;
  productModuleName: string;
  productSysName: string | null;
  deployMode: number;
  deployStatus: string | null;
  authorizeAddress: string | null;
  createTime: number;
  envName: string | null;
}

interface IProps {
  changeCurrent: (progress: string) => void;
}

const SelectEnv = (props: IProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { changeCurrent } = props;
  const envInfo = useSelector((state: reducerStates) => state.envManage);
  const runtimeEnvId = envInfo.runtimeEnvId || sessionStorage.getItem('runtimeEnvId');
  const [activeKey, setActiveKey] = useState('');
  const [envData, setEnvData] = useState<IEnvType | null>();
  const [spinning, setSpinning] = useState(false);
  const tempArr = ['alone', 'colony', 'nanotube'];

  useEffect(() => {
    if (!runtimeEnvId) return;
    getNanotubeDataApi({ id: runtimeEnvId as string }).then((res) => {
      const { data = [] } = res;
      setEnvData(data[0]);
    });
  }, []);

  const changeEnvEvent = (type: string) => {
    dispatch(
      envManage.changeEnvStatus({
        cluster: type === 'colony',
      }),
    );
    const envStatus = JSON.parse(sessionStorage.getItem('envStatus') || '{}');
    envStatus.cluster = type === 'colony' ? 1 : 0;
    sessionStorage.setItem('envStatus', JSON.stringify(envStatus));
    navigate('/instances');
  };

  const changeEnv = (type: string) => {
    setActiveKey(type);
    if (type === 'nanotube') {
      // 查询是否是在纳管中
      checkNanotubeApi().then((res) => {
        const { data } = res;
        if (data) {
          dispatch(changeStatus(data));
          dispatch(chagnePage('deploying'));
        }
        changeCurrent('form');
      });

      return;
    }
    const obj = runtimeEnvId
      ? {
          ...envData,
          deployMode: tempArr.indexOf(type),
        }
      : {
          deployMode: tempArr.indexOf(type),
          envName: 'supos',
          createTime: new Date().getTime(),
        };
    setSpinning(true);
    updateNanotubeDataApi(obj).then(() => {
      setSpinning(false);
      changeEnvEvent(type);
    });
  };

  return (
    <Spin spinning={spinning}>
      <div className={styles.select_env}>
        <h1 className={styles.title}>{intl.formatMessage(messages.checkEnvTitle)}</h1>

        <Row>
          {/* <Col span={8}>{intl.formatMessage(messages.hasNanotube)}</Col> */}
          <Col span={14}>{intl.formatMessage(messages.hasNotNanotube)}</Col>
        </Row>

        <Row>
          {/* <Col
            span={7}
            className={`${styles.nanotube} ${activeKey === 'nanotube' ? styles.active : ''}`}
            onClick={() => changeEnv('nanotube')}
          >
            <img src={nanotube} />
            <div className={styles.titleFont}>{intl.formatMessage(messages.nanotube)}</div>
          </Col> */}
          <Col
            span={7}
            className={`${styles.nanotube} ${activeKey === 'alone' ? styles.active : ''}`}
            onClick={() => changeEnv('alone')}
          >
            <img src={alone} />
            <div className={styles.titleFont}>{intl.formatMessage(messages.alone)}</div>
          </Col>
          <Col
            span={7}
            className={`${styles.nanotube} ${activeKey === 'colony' ? styles.active : ''}`}
            onClick={() => changeEnv('colony')}
          >
            <img src={colony} />
            <div className={styles.titleFont}>{intl.formatMessage(messages.colony)}</div>
          </Col>
        </Row>
      </div>
    </Spin>
  );
};

export default SelectEnv;
